module.exports = __webpack_public_path__ + "media/images/icon-question-06060c3e55b8479b5904bb1c39482684.svg";